import { ConditionOperator } from 'src/graphql/types';

export const ARCHIVE_EXIT_TIMEOUT_MS = 220;

export const KEYBOARD_OPEN_DEBOUNCE_MS = 600;

export const INBOX_PANE_ITEM_TEST_ID = 'inbox-pane-item';

export const INBOX_PANE_ITEM_META_TEST_ID = 'inbox-pane-item-meta';

export const INBOX_PANE_ITEM_ACTIONS_TEST_ID = 'inbox-pane-item-actions';

export const INBOX_PANE_ITEM_UNREAD_DOT_TEST_ID = 'inbox-pane-item-unread-dot';

export const INBOX_PANE_ITEM_SNIPPET_TEST_ID = 'inbox-pane-item-snippet';

export const INBOX_PANE_ITEM_TOOLTIP_MESSAGE_TEST_ID = 'inbox-pane-item-tooltip-message';

// shared Tooltip defaults to 1000ms; inbox rows need a snappier hover
export const SNIPPET_TOOLTIP_ENTER_DELAY_MS = 10;

// "is any of" / "is not any of" leave no room for the values in a 248px pane
export const INBOX_FILTER_OPERATOR_DISPLAY: Partial<Record<ConditionOperator, string>> = {
  [ConditionOperator.In]: 'is',
  [ConditionOperator.NotIn]: 'is not',
};

export const SWIPE_ARCHIVE_THRESHOLD_PX = 80;

export const ROW_MENU_LONG_PRESS_MS = 400;

// abandon the press past this much movement, so swipe-to-archive can't also open the menu
export const ROW_MENU_LONG_PRESS_MOVE_TOLERANCE_PX = 12;

export const READ_ROW_DIM_OPACITY = 0.55;

export const INBOX_PANE_ALL_CLEAR_TEST_ID = 'inbox-pane-all-clear';

export const INBOX_PANE_NO_MATCH_TEST_ID = 'inbox-pane-no-match';

export const INBOX_PANE_CLEAR_FILTER_TEST_ID = 'inbox-pane-clear-filter';
